<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="$vuetify.breakpoint.thresholds.md"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    scrollable
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar
          flat
          color="white"
          style="font-size: 13px"
          dense>

            <span>Свойства для <span
              class="accent--text">{{ item.nomenklatura_id }}</span> {{ item.name }}</span>

          <v-spacer></v-spacer>
          <div class="item-available">
            <v-progress-circular
              v-if="availableDataLoading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <template v-else>
              <span class="accent--text">Доступно {{itemsAvailable}} шт</span>
            </template>
          </div>
          <div class="item-price">
            <v-progress-circular
              v-if="availableDataLoading"
              indeterminate
              color="primary"
            ></v-progress-circular>
            <template v-else>
              <span class="accent--text">{{ item.tsena }}</span>
            </template>
          </div>
          <div class="items-kolichestvo-container">
            <input
              ref="kolichestvo"
              v-model.number="item.kolichestvo"
              type="number"
              min="1"
              v-numericOnly
              pattern="\d*"
              class="table-qty">
          </div>
        </v-toolbar>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <template subheader v-for="attribute in attributes">
          <div :key="attribute.attribute_id">
            <template v-if="attribute.attribute_type === 'list'">
              <v-list dense subheader>
                <v-subheader class="body-1">{{ attribute.attribute_name }}</v-subheader>
                <v-list-tile v-for="option in attribute.options" :key="option.attribute_option_id">
                  <v-checkbox
                    v-model="attribute.value"
                    :value="option.attribute_option_id"
                    :label="option.attribute_option_name"
                    @change="calculateAvailableData"
                  ></v-checkbox>
                </v-list-tile>
              </v-list>
            </template>
            <template v-else-if="attribute.attribute_type === 'image'">
              <v-item-group v-model="attribute.value" @change="calculateAvailableData">
                <v-container grid-list-md fluid class="pa-0 pb-3">
                  <v-subheader>{{ attribute.attribute_name }}</v-subheader>
                  <v-layout row wrap class="pl-3 pr-3">
                    <v-flex
                      v-for="option in attribute.options" :key="option.attribute_option_id"
                      xs12
                      sm4
                      md2
                      d-flex
                    >
                      <v-item :value="option.attribute_option_id">
                        <v-card
                          slot-scope="{ active, toggle }"
                          tile
                          class="d-flex"
                          @click="toggle"
                          style="position: relative;"
                        >
                          <v-img
                            :src="`${endpointUrl}/images/get_image/${option.attribute_option_file_name}`"
                            contain
                            aspect-ratio="1"
                          >
                            <template v-slot:placeholder>
                              <v-layout
                                fill-height
                                align-center
                                justify-center
                                ma-0
                              >
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-layout>
                            </template>
                          </v-img>
                          <v-scale-transition>
                            <div
                              v-if="active"
                              class="image-selected"
                            >
                            </div>
                          </v-scale-transition>
                        </v-card>
                      </v-item>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-item-group>
            </template>
          </div>
        </template>

        <template subheader v-for="topping in toppings">
          <div :key="topping.topping_id">
            <v-subheader class="body-1">{{ topping.topping_name }}</v-subheader>
            <v-radio-group
              class="ma-0 pl-3"
              v-model="topping.value"
              @change="calculateAvailableData"
            >
              <v-radio
                v-for="option in topping.options"
                :key="option.topping_option_id"
                :label="option.topping_option_name"
                :value="option.topping_option_id"
              ></v-radio>
            </v-radio-group>
          </div>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="deleteRecordFromDocument" v-if="recordIsInDocument">Удалить</v-btn>
        <v-btn color="success" @click="saveRecordToDocument" :disabled="item.kolichestvo <= 0 || itemsAvailable <=0">Сохранить</v-btn>
        <v-btn @click="dialog = false" color="secondary">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CatalogApi from '../../app/catalog/api'

export default {
  name: 'ProductOptions',
  data () {
    return {
      docId: 0,
      buh: 0,
      fromCatalog: true,
      availableDataLoading: false,
      itemsAvailable: 0,
      isLoading: false,
      dialog: false,
      item: {
        name: '',
        nomenklatura_id: '',
        kolichestvo: 0,
        warranty: 0,
        tsena: 0,
        st: 0,
        attributes: [],
        toppings: []
      },
      attributes: [],
      toppings: []
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _currentDocument: 'currentDocument'
    }),
    recordIsInDocument () {
      return !!this._currentDocument.records.find((record) => record.nomenklatura_id === this.item.nomenklatura_id)
    },
    endpointUrl () {
      return process.env.VUE_APP_ENDPOINT_URL
    }
  },
  methods: {
    ...mapActions('catalog', {
      _addRecordToDocument: 'addRecordToDocument',
      _updateRecordToDocument: 'updateRecordToDocument',
      _refreshItemsTableQuantity: 'refreshItemsTableQuantity'
    }),
    open (item, fromCatalog = true, docId = 0, buh = 0) {
      this.docId = docId
      this.fromCatalog = fromCatalog
      this.buh = buh
      this.item = { ...item }
      this.dialog = true
      this.loadOptions(this.item.nomenklatura_id)
    },
    async loadOptions (productId) {
      this.isLoading = true
      let response = await CatalogApi.loadOptions(productId)
      this.isLoading = false
      this.attributes = response.attributes
      this.toppings = response.toppings
      if (this.item.attributes) {
        this.item.attributes.forEach((itemAttribute) => {
          this.attributes.forEach((attribute) => {
            if (parseInt(itemAttribute.attribute_id) === parseInt(attribute.attribute_id)) {
              attribute.value = itemAttribute.value
            }
          })
        })
      }

      if (this.item.toppings) {
        this.item.toppings.forEach((itemTopping) => {
          this.toppings.forEach((topping) => {
            if (parseInt(itemTopping.topping_id) === parseInt(topping.topping_id)) {
              topping.value = itemTopping.value
            }
          })
        })
      }
      this.calculateAvailableData()
    },
    async calculateAvailableData () {
      this.availableDataLoading = true
      let response = await CatalogApi.getItemsAvailable({
        buh: this.buh,
        nomenklatura_id: this.item.nomenklatura_id,
        docId: this.docId,
        attributes: this.attributes.map(attribute => ({
          attribute_id: attribute.attribute_id,
          value: attribute.value
        })),
        toppings: this.toppings.map(topping => ({
          topping_id: topping.topping_id,
          value: topping.value
        }))
      })

      this.itemsAvailable = response.quantity
      this.item.name = response.name
      this.item.tsena = response.price
      this.availableDataLoading = false
    },

    saveRecordToDocument () {
      if (this.fromCatalog) {
        let recordInDocument = this._currentDocument.records.find((obj) => obj.nomenklatura_id === this.item.nomenklatura_id)
        let record = {
          nomenklatura_id: this.item.nomenklatura_id,
          kolichestvo: this.item.kolichestvo,
          name: this.item.name,
          warranty: this.item.warranty,
          tsena: this.item.tsena,
          st: this.item.st,
          attributes: this.attributes.filter(attribute => !!attribute.value).map(attribute => ({
            attribute_id: attribute.attribute_id,
            value: attribute.value

          })),
          toppings: this.toppings.filter(topping => !!parseInt(topping.value)).map(topping => ({
            topping_id: topping.topping_id,
            value: topping.value
          }))
        }
        recordInDocument ? this._updateRecordToDocument(record) : this._addRecordToDocument(record)
        this._refreshItemsTableQuantity()
      } else {
        this.item.attributes = this.attributes.filter(attribute => !!attribute.value).map(attribute => ({
          attribute_id: attribute.attribute_id,
          value: attribute.value
        }))

        this.item.toppings = this.toppings.filter(topping => !!topping.value).map(topping => ({
          topping_id: topping.topping_id,
          value: topping.value
        }))
        this.$emit('updateDocumentRecord', this.item)
      }

      this.dialog = false
    },
    deleteRecordFromDocument () {
      this._updateRecordToDocument({
        nomenklatura_id: this.item.nomenklatura_id,
        kolichestvo: 0
      })
      this._refreshItemsTableQuantity()
      this.dialog = false
    }
  }
}
</script>

<style lang="stylus" scoped>
  .image-selected {
    position absolute
    width 100%
    height 6px
    opacity 0.8
    background-color var(--v-accent-base)
    bottom 0
    left 0
  }

  .item-available {
    width 130px
    text-align center
    border-left 1px solid rgba(0, 0, 0, 0.12)
    border-right 1px solid rgba(0, 0, 0, 0.12)
    height 100%
    align-items center
    justify-content center
    display flex
  }

  .item-price {
    width 90px
    text-align center
    border-right 1px solid rgba(0, 0, 0, 0.12)
    height 100%
    align-items center
    justify-content center
    display flex
  }

  .items-kolichestvo-container {
    padding-left 24px
  }
</style>
